
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concierge/car",
      function () {
        return require("private-next-pages/concierge/car.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concierge/car"])
      });
    }
  